import app from 'flarum/forum/app';
import Link from 'flarum/common/components/Link';
import { kindLabel, storyDate, loadStories, chronological } from './common';
import { t, route } from '../../i18n';

/**
 * Blok "The Dark Pages" op een clubpagina: de zware verhalen waarin deze club voorkomt.
 * Wordt als methode op ClubPage gezet (ClubPage roept this.darkPages() aan, als die bestaat).
 */
export default function darkPages() {
  if (!this.darkStories) {
    this.darkStories = [];
    loadStories().then((stories) => {
      this.darkStories = chronological(stories);
      m.redraw();
    });
  }

  const slug = this.club.slug();
  const items = this.darkStories.filter((s) => (s.clubSlugs() || []).includes(slug) && s.isPublished());
  if (!items.length) return null;

  return (
    <section className="LcSection LcClubDark" id="dark-pages">
      <div className="LcSection-head">
        <h2>The Dark Pages</h2>
        <span className="LcSection-count">{items.length}</span>
      </div>
      <p className="LcNote">{t('dark.club_note', { name: this.club.name() })}</p>
      <ul className="LcClubDark-list">
        {items.map((s) => (
          <li>
            <Link href={route('lc.dark.story', { slug: s.slug() })}>
              <span className="LcClubDark-meta">
                {kindLabel(s.kind())} · {storyDate(s)}
              </span>
              <strong>{s.title()}</strong>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
